import { USER_ROLES } from "@/lib/constants/roles";
import { CompanyRole } from "@/lib/miscellaneous/authorization";
import { t } from "i18next";
import * as z from "zod";
export const formSchema = z
  .object({
    userType: z.enum(["company", "accounting_firm"]),
    name: z.string().trim().min(2, t("name_required")),
    email: z.string().trim().toLowerCase().email(t("email_required")),
    accountingFirmRole: z.enum([USER_ROLES.USER, USER_ROLES.ADMIN]).optional(),
    companyAccess: z.array(
      z.object({
        companyId: z.string(),
        role: z.nativeEnum(CompanyRole),
      }),
    ),
  })
  .superRefine((data, ctx) => {
    if (data.userType === "accounting_firm" && !data.accountingFirmRole) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["accountingFirmRole"],
        message: t("role_required"),
      });
    }
    if (
      data.userType === "company" &&
      (!data.companyAccess || data.companyAccess.length === 0)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["companyAccess"],
        message: t("users.at_least_one_access"),
      });
    }
  });

export type FormValues = z.infer<typeof formSchema>;
